import React from 'react'
import ReactModal from 'react-modal'
import closeIcon from '../../assets/icons/close.svg'
import '../../styles/scss/components/equote-package-terms-modal.scss'

const EQuoteTermsModal = props => {
  const { title, content, onRequestClose, isOpen, brandClassName } = props
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={{
        base: `equote__terms_modal u-modal ${
          brandClassName ? brandClassName : ''
        }`,
        afterOpen: 'u-modal--visible',
        beforeClose: 'u-modal--close',
        ariaHideApp: false
      }}
      overlayClassName={{
        base: 'u-fade',
        afterOpen: 'u-fade--visible',
        beforeClose: 'u-fade--visible'
      }}
      ariaHideApp={false}
      htmlOpenClassName="ReactModal__Html--open"
    >
      <div className="u-modal__header">
        <h2 className="u-remove-margin"> </h2>
        <div className="u-modal__close" onClick={onRequestClose} tabIndex={0}>
          Close
          <img
            className="u-modal__close-icon"
            src={closeIcon}
            alt={`${title} Modal Close`}
          />
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </ReactModal>
  )
}

export default EQuoteTermsModal
